interface IIcon {
  width?: string;
  height?: string;
}
const ExcelFileIcon = ({ width = '16', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.39999 20.4008C2.39999 21.0636 2.93719 21.6008 3.59999 21.6008H5.19999V18.8008H3.19999C3.19999 18.8008 2.39999 18.8008 2.39999 20.4008Z"
      fill="#5AA064"
    />
    <path
      d="M21.6 4.80039V22.0004C21.6 22.884 20.8836 23.6004 20 23.6004H6.39999C5.51639 23.6004 4.79999 22.884 4.79999 22.0004V2.00039C4.79999 1.11679 5.51639 0.400391 6.39999 0.400391H17.2L21.6 4.80039Z"
      fill="#E8ECEF"
    />
    <path
      d="M21.6 4.80039H17.6C17.38 4.80039 17.2 4.62039 17.2 4.40039V0.400391L21.6 4.80039Z"
      fill="#C7D0DD"
    />
    <path
      d="M3.59999 19.1992H18C18.6628 19.1992 19.2 18.662 19.2 17.9992V12.3992C19.2 11.7364 18.6628 11.1992 18 11.1992H3.59999C2.93719 11.1992 2.39999 11.7364 2.39999 12.3992V20.3992C2.39999 19.7364 2.93719 19.1992 3.59999 19.1992Z"
      fill="#61C161"
    />
    <path
      d="M12 16.8008H10V13.2008C10 12.9796 9.82081 12.8008 9.60001 12.8008C9.37921 12.8008 9.20001 12.9796 9.20001 13.2008V17.2008C9.20001 17.422 9.37921 17.6008 9.60001 17.6008H12C12.2208 17.6008 12.4 17.422 12.4 17.2008C12.4 16.9796 12.2208 16.8008 12 16.8008Z"
      fill="white"
    />
    <path
      d="M8.20601 12.8579C8.01641 12.7443 7.77081 12.8055 7.65721 12.9951L6.80001 14.4235L5.94281 12.9951C5.82921 12.8055 5.58361 12.7447 5.39401 12.8579C5.20441 12.9715 5.14321 13.2171 5.25681 13.4067L6.33321 15.2007L5.25681 16.9947C5.14321 17.1843 5.20441 17.4299 5.39401 17.5435C5.45841 17.5823 5.52921 17.6007 5.59961 17.6007C5.73561 17.6007 5.86801 17.5315 5.94281 17.4067L6.80001 15.9783L7.65721 17.4067C7.73241 17.5315 7.86481 17.6007 8.00041 17.6007C8.07041 17.6007 8.14161 17.5823 8.20601 17.5435C8.39561 17.4299 8.45681 17.1843 8.34321 16.9947L7.26681 15.2007L8.34321 13.4067C8.45681 13.2171 8.39561 12.9715 8.20601 12.8579Z"
      fill="white"
    />
    <path
      d="M14.8968 14.8124C14.202 14.6384 14 14.5372 14 14.2004C14 13.8752 14.3664 13.6004 14.8 13.6004C15.366 13.6004 15.636 14.0424 15.652 14.07C15.76 14.2608 16.0012 14.3296 16.194 14.2224C16.3868 14.1152 16.4568 13.872 16.3496 13.6788C16.3296 13.6428 15.8504 12.8008 14.8 12.8008C13.9176 12.8008 13.2 13.4288 13.2 14.2008C13.2 15.2132 14.1044 15.4392 14.7032 15.5888C15.398 15.7628 15.6 15.864 15.6 16.2008C15.6 16.526 15.2336 16.8008 14.8 16.8008C14.2288 16.8008 13.9588 16.35 13.9496 16.3344C13.842 16.1412 13.6 16.0708 13.406 16.1788C13.2132 16.286 13.1432 16.5292 13.2504 16.7224C13.2704 16.7584 13.7496 17.6004 14.8 17.6004C15.6824 17.6004 16.4 16.9724 16.4 16.2004C16.4 15.188 15.4956 14.962 14.8968 14.8124Z"
      fill="white"
    />
  </svg>
);

export default ExcelFileIcon;
